import heic2any from "heic2any";
import * as R from "ramda";
import React, {useEffect, useRef, useState} from "react";
import FlexView from "react-flexview";
import DefaultImage from "../../assets/img/upload img.jpg";
import SimpleButton from "../commons/SimpleButton";

export default function SimpleUploadImage({
                                              value,
                                              shape,
                                              onChange,
                                              mandatory,
                                              errorMessage,
                                              readOnly,
                                              category,
                                              downloadedFileName,
                                              ...props
                                          }) {
    const [image, setImage] = useState(DefaultImage);
    const [processing, setProcessing] = useState(false);

    useEffect(() => {
        if (R.isNil(value) || R.isEmpty(value)) {
            setImage(DefaultImage);
        } else {
            setImage(value);
        }
    }, [value]);

    const handleUploadImage = (e) => {
        const file = e.target.files[0];
        const maxSize = 13 * 1024 * 1024; // 13MB
        if (!file) {
            return;
        }

        if (file.size >= maxSize) {
            return;
        }

        setBase64(file, e.target.name);
    };

    const setBase64 = (file, name) => {
        if (file.name.toUpperCase().includes("HEIC")) {
            convertHEICToBase64(file, (base64) => setData(base64, name), console.warn);
            return;
        }
        convertBlobToBase64(file, (base64) => setData(base64, name), console.warn);
    };

    const convertHEICToBase64 = async (file, onSuccess, onError) => {
        setProcessing(true);
        try {
            const blob = await heic2any({
                blob: file,
                toType: "image/jpeg",
            });

            convertBlobToBase64(blob, onSuccess, onError);
        } catch (error) {
            onError(error);
        }
        setProcessing(false);
    };

    const convertNonPNGToBase64 = (file, onSuccess, onError) => {
        const reader = new FileReader();
        reader.onload = () => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.getElementById("hiddenCanvas");
                const ctx = canvas.getContext("2d");

                canvas.width = img.width;
                canvas.height = img.height;

                ctx.drawImage(img, 0, 0);

                const base64 = canvas.toDataURL("image/png");
                onSuccess(base64);
            };

            img.onerror = onError;
            img.src = reader.result;
        };

        reader.onerror = onError;
        reader.readAsDataURL(file);
    };

    const convertBlobToBase64 = (file, onSuccess, onError) => {
        const reader = new FileReader();
        reader.onload = () => {
            onSuccess(reader.result);
        };
        reader.onerror = onError;
        reader.readAsDataURL(file);
    };

    const setData = (base64, name) => {
        onChange(base64, name);
        setImage(base64);
    };

    const handleDownloadImage = async () => {
        if (!image || R.equals(image, DefaultImage)) {
            alert("Silahkan upload gambar terlebih dahulu.");
            return;
        }
        let extensions = getMimeTypeFromBase64(image);

        console.log("extensions", extensions);

        if (R.equals("HEIC", extensions.toUpperCase())) {
            convertHEICBase64ToPNG(image, (base64) => downloadImage(base64), console.warn);
        } else if (!R.equals("PNG", extensions.toUpperCase())) {
            convertNonPNGBase64ToPNG(image, (base64) => downloadImage(base64), console.warn);
        } else {
            downloadImage(image)
        }
    }

    const downloadImage = async (image) => {
        const link = document.createElement("a");
        link.href = image;
        link.download = downloadedFileName || "downloaded-image.png";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const getMimeTypeFromBase64 = (base64) => {
        const match = base64.match(/^data:(.*?);base64,/);
        return match ? getFileExtensionFromMimeType(match[1]) : null;
    }

    const getFileExtensionFromMimeType = (mimeType) => {
        const map = {
            'image/jpeg': 'jpg',
            'image/png': 'png',
            'image/gif': 'gif',
            'image/webp': 'webp',
            'application/pdf': 'pdf',
            // Add more as needed
        };
        return map[mimeType] || 'bin';
    }

    const convertHEICBase64ToPNG = async (base64Input, onSuccess, onError) => {
        setProcessing(true);
        const base64Data = base64Input.replace(/^data:image\/heic;base64,/, "");

        const binaryString = atob(base64Data);
        const binaryLength = binaryString.length;
        const byteArray = new Uint8Array(binaryLength);

        for (let i = 0; i < binaryLength; i++) {
            byteArray[i] = binaryString.charCodeAt(i);
        }

        const heicBlob = new Blob([byteArray], {type: "image/heic"});
        try {
            const blob = await heic2any({
                blob: heicBlob,
                toType: "image/png",
            });

            convertBlobToBase64(blob, onSuccess, onError);
        } catch (error) {
            onError(error);
        }
        setProcessing(false);
    };

    const convertNonPNGBase64ToPNG = (base64Input, onSuccess, onError) => {
        const img = new Image();
        img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            // Convert to PNG Base64
            const base64Png = canvas.toDataURL("image/png");
            console.log("base64png", base64Png);
            onSuccess(base64Png);
        };

        img.onerror = onError;
        img.src = base64Input;
    };

    const fileInputRef = useRef(null);
    const handleUploadClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const shapeStyle = R.equals(shape, "circle") ? "circle" : "default";
    return (
        <div className={`margin-bottom-20px ${props.containerclassname}`}>
            <div className="margin-5px">
                <div className="txt-site txt-11 txt-main txt-bold">
                    <h4>
                        {props.label} {mandatory && <span style={{color: "red"}}>*</span>}
                    </h4>
                </div>
            </div>
            <FlexView column hAlignContent="center" style={{gap: "8px"}}>
                <canvas id="hiddenCanvas" hidden/>
                <img src={image} className={`upload-pict ${shapeStyle}`}
                     style={{objectFit: "contain", width: "100%", height: "100%"}}/>
                <div style={{alignSelf: "end"}}>

                    <div>
                        {
                            R.equals(category, "upload-download") || R.equals(category, "download-upload") ?
                                (
                                    <FlexView hAlignContent={"right"} style={{alignItems: "center", alignSelf: "end"}}>
                                        <input
                                            ref={fileInputRef}
                                            type="file"
                                            disabled={processing || readOnly}
                                            accept={props.accept ? props.accept : ".jpg,.jpeg,.png,.heic"}
                                            onChange={handleUploadImage}
                                            hidden
                                            {...props}
                                        />
                                        <SimpleButton
                                            // secondary
                                            className="margin-top-5px flex-1"
                                            type="button"
                                            text="Upload Photo"
                                            onClick={handleUploadClick} // Trigger file input on button click
                                        />
                                        <SimpleButton
                                            // secondary
                                            className="margin-top-5px flex-1"
                                            type="button"
                                            text="Download Photo"
                                            onClick={handleDownloadImage}
                                        />
                                    </FlexView>
                                ) : R.equals(category, "upload") ?
                                    (
                                        <>
                                            <input
                                                ref={fileInputRef}
                                                type="file"
                                                disabled={processing || readOnly}
                                                accept={props.accept ? props.accept : ".jpg,.jpeg,.png,.heic"}
                                                onChange={handleUploadImage}
                                                hidden
                                                {...props}
                                            />
                                            <SimpleButton
                                                // secondary
                                                className="margin-top-5px flex-1"
                                                type="button"
                                                text="Upload Photo"
                                                onClick={handleUploadClick} // Trigger file input on button click
                                            />
                                        </>
                                    ) : R.equals(category, "download") ?
                                        (
                                            <SimpleButton
                                                // secondary
                                                className="margin-top-5px flex-1"
                                                type="button"
                                                text="Download Photo"
                                                onClick={handleDownloadImage}
                                            />
                                        ) : R.isNil(category) ?
                                            (
                                                <>
                                                    <input
                                                        ref={fileInputRef}
                                                        type="file"
                                                        disabled={processing || readOnly}
                                                        accept={props.accept ? props.accept : ".jpg,.jpeg,.png,.heic"}
                                                        onChange={handleUploadImage}
                                                        hidden
                                                        {...props}
                                                    />
                                                    <SimpleButton
                                                        // secondary
                                                        className="margin-top-5px flex-1"
                                                        type="button"
                                                        text="Upload Photo"
                                                        onClick={handleUploadClick} // Trigger file input on button click
                                                    />
                                                </>
                                            ) : (<></>)
                        }

                    </div>
                </div>
            </FlexView>
            {mandatory && errorMessage && (
                <p className="txt-site txt-11 color-red margin-top-5px">{errorMessage}</p>
            )}
        </div>
    );
}
